<template>
  <b-container>
      <b-card>
        <!-- Form -->
         <ReviewStep
          :basic-data="formData.basicData"
          :juridical-documentation="formData.juridicalDocumentation"
          :economic-operational-data="formData.economicOperationalData"
          :linked-institutions="formData.linkedInstitutions"
          :additional-attachments="formData.additionalAttachments"
          :activity-areas="activityAreas"
          :organization-sizes="organizationSizes"
          :disabled="true" />

        <!-- End Form-->
        <!-- Handling -->
        <b-row class="m-0 mt-2 no-print">
          <b-col
            lg="12">
            <b-form @submit.prevent="saveHandling">
              <b-row class="m-0" >
                <b-col md="6" sm="6">
                  <validation-provider
                      #default="validationContext"
                      :name="$t('status')"
                      rules="required"
                      class="flex-grow"
                      slim>
                    <b-form-group
                      :label="$t('status')"
                      label-for="status">
                      <b-form-select
                        id="status"
                        class="required-select"
                        :options="listStatus"
                        text-field="label"
                        value-field="key"
                        v-model="modelStatus">
                        <!-- This slot appears above the options from 'options' prop -->
                        <template #first>
                          <b-form-select-option :value="null" disabled>-- Selecione uma opção --</b-form-select-option>
                        </template>
                      </b-form-select>
                        <b-form-invalid-feedback :class="[{'absolute': inline}]">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    </validation-provider>
                </b-col>
                <b-col lg="4" md="6" sm="6" class="print:hidden">
                  <HandlingHistoryPopup :id="id"
                    :serviceDelegate="services.handling"
                    :isTextTreatmentOnly="true" />
                </b-col>
              </b-row>
              <b-row class="m-0" >
                <b-col>
                  <!-- publicAccess -->
                  <b-form-group
                    :label="$t('preview')"
                    label-for="publicAccess">
                    <b-form-radio-group
                      id="publicAccess"
                      name="publicAccess"
                      v-model="publicAccess">
                      <b-form-radio :value="false">{{$t('private')}}</b-form-radio>
                      <b-form-radio :value="true">{{$t('public')}}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group
                    :label="$t('form_handling')"
                    label-for="treatment">
                    <simple-editor v-model="textTreatment" class="mb-2"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="m-0 pt-2" >
                <b-col>
                  <b-form-group
                    :label="$t('forwarding_description_public')"
                    label-for="forwarding_description">
                    <simple-editor v-model="forwardingDescription" class="mb-2"/>
                    </b-form-group>
                </b-col>
              </b-row>
              <div class="mt-1 mb-2">
                <div class="flex justify-end">
                     <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-1 mr-1 float-right"
                    :disabled="!validateForm"
                    @click="saveHandling()">
                      {{$t('save')}}
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-secondary"
                    class="mt-1 mr-1 float-right"
                            @click="$router.push('/portal-cebas/credentialings/handlings')">
                      {{$t('back')}}
                  </b-button>
                </div>
              </div>
            </b-form>
          </b-col>
        </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
//

//
import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

//Services
import CebasCredentialingHandlingService from '@/services/api/cebas/CebasCredentialingHandlingService'
import CebasCredentialingService from '@/services/api/cebas/CebasCredentialingService'
import GenericService from '@/services/api/GenericService'

import ReviewStep from '@/views/apps/portal-cebas/credentialing/steps/ReviewStep.vue'
import HandlingHistoryPopup from '@/components/popup/HandlingHistoryPopup'
import SimpleEditor from '@/components/SimpleEditor.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BTable,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    VBTooltip,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    ReviewStep,
    HandlingHistoryPopup,
    SimpleEditor,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    formHandling : {},
    formData : {
      status: '',
      basicData: {},
      juridicalDocumentation: {},
      economicOperationalData: {},
      linkedInstitutions: [],
      additionalAttachments: [],
    },
    textTreatment: '',
    forwardingDescription: '',
    publicAccess: false,
    status: '',
    modelStatus: null,
    listStatus: [],
    services: {
      handling: null,
      form: null,
    },
  }),
  methods: {
    saveHandling(){
      this.save(this.modelStatus)
    },
    save(varStatus) {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      this.services.handling.updateHandling(this.id, {
          id: this.id,
          description: this.textTreatment,
          forwarding_description: this.forwardingDescription,
          public_access: this.publicAccess,
          status: varStatus,
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.clearFields()
            this.sucessNotify()
            //Update status view
            this.requestForm = data
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    getData(id) {
      this.$vs.loading()
      this.services.handling.read(id).then(
        data => {
          this.formHandling = data;
          this.status = data.status;

          //Get form
          this.loadForm(data.form.id)
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(() => this.$vs.loading.close())
    },
    loadForm(id) {
      this.$vs.loading()
      this.services.form.read(id).then(
        data => {
          this.loadExistingCredentialingData(data)
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(() => this.$vs.loading.close())
    },
    loadExistingCredentialingData(data) {
      this.formData.status = data.status;

      // Carrega os dados dos steps
      if (data.steps_data) {
        // Garante que os dados básicos estejam corretos
        if (data.steps_data.basic_data) {
          // Preserva os valores existentes
          const currentBasicData = this.formData.basicData || {};

          // Atualiza com os novos dados
          this.formData.basicData = {
            ...currentBasicData,
            ...data.steps_data.basic_data,
            // Garante que os valores específicos sejam mantidos
            credentialing_type: data.steps_data.basic_data.credentialing_type || currentBasicData.credentialing_type || null,
            activity_area: data.steps_data.basic_data.activity_area || currentBasicData.activity_area || null
          };
        }

        // Mapeia a documentação jurídica com status de uploaded correto
        const juridicalDocs = data.steps_data.juridical_documentation || {};
        this.formData.juridicalDocumentation = {};

        // Mapeia cada documento jurídico para ter a estrutura correta
        Object.keys(juridicalDocs).forEach(docKey => {
          if (juridicalDocs[docKey] && typeof juridicalDocs[docKey] === 'object') {
            this.formData.juridicalDocumentation[docKey] = {
              ...juridicalDocs[docKey],
              uploaded: true,
              metadata: {
                original_name: juridicalDocs[docKey].original_name || juridicalDocs[docKey].name || juridicalDocs[docKey].file_name,
                size: juridicalDocs[docKey].size,
                type: juridicalDocs[docKey].type || juridicalDocs[docKey].mime_type,
                document_type: docKey
              }
            };
          }
        });

        console.log('Dados carregados - juridicalDocumentation:', this.formData.juridicalDocumentation);

        this.formData.economicOperationalData = data.steps_data.economic_operational_data || {};
        this.formData.linkedInstitutions = Array.isArray(data.steps_data.linked_institutions) ? data.steps_data.linked_institutions : [];

        // Atualiza os anexos complementares com a estrutura correta
        const additionalAttachments = data.steps_data.additional_attachments || [];
        this.formData.additionalAttachments = {
          additional_attachments: Array.isArray(additionalAttachments)
            ? additionalAttachments.map(attachment => ({
                ...attachment,
                uploaded: true,
                metadata: {
                  original_name: attachment.original_name || attachment.name,
                  size: attachment.size,
                  type: attachment.type,
                  document_type: 'additional_attachment'
                }
              }))
            : []
        };

        console.log('Dados carregados - additionalAttachments:', this.formData.additionalAttachments);
      }
    },
    clearFields() {
      this.textTreatment = ''
      this.forwardingDescription = ''
      this.modelStatus = null
    },
    confirmClosed() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja encerrar o atendimento?',
        accept: () => {
          this.saveClose()
        }
      })
    },
    sucessNotify() {
      this.$vs.notify({
        title: 'Successo!',
        text: 'Operação realizada com sucesso.',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
    },
  },
  computed: {
    validateForm() {
      return this.modelStatus !== null
    }
  },
  mounted() {
    //this.$vs.loading.close()
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {
    //this.$vs.loading()
    const promisses = []

    this.services.handling = CebasCredentialingHandlingService.build(this.$vs)
    this.services.form = CebasCredentialingService.build(this.$vs)
    this.services.genericService = GenericService.build(this.$vs)

    promisses.push(
      this.services.genericService.getFormHandlingStatus(this.id).then(
        data => {
          this.listStatus = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )


  }
}
</script>
<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
</style>
